var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Song Management" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  {
                    staticClass: "pb-3 flex justify-between items-center w-full"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col items-center w-full" },
                      [
                        _c(
                          "el-row",
                          { staticClass: "w-full pb-3", attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "search album name" },
                                  on: { change: _vm.searchMusic },
                                  model: {
                                    value: _vm.filters,
                                    callback: function($$v) {
                                      _vm.filters = $$v
                                    },
                                    expression: "filters"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isArtist
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "search artist name"
                                      },
                                      on: { change: _vm.searchMusic },
                                      model: {
                                        value: _vm.filterName,
                                        callback: function($$v) {
                                          _vm.filterName = $$v
                                        },
                                        expression: "filterName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isArtist
                              ? _c(
                                  "el-col",
                                  {
                                    staticClass: "flex flex-row",
                                    attrs: { span: 4 }
                                  },
                                  [
                                    _c("Button", {
                                      attrs: { label: "Apply" },
                                      on: { clicked: _vm.searchMusic }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      { staticClass: "p-2" },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: ["fas", "sync"] },
                                          on: { click: _vm.resetMusic }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticClass: "w-full pb-3", attrs: { gutter: 10 } },
                          [
                            !_vm.isArtist
                              ? _c(
                                  "el-col",
                                  {
                                    staticClass: "flex flex-row gap-3",
                                    attrs: { span: 24 }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-50 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 0
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 0
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Waiting For Review (" +
                                                    _vm._s(
                                                      _vm.countWaitingForReview
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-40 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 1
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 1
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Under Review (" +
                                                    _vm._s(
                                                      _vm.countUnderReview
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-40 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 2
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 2
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Approved (" +
                                                    _vm._s(_vm.countApproved) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-40 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 3
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 3
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium "
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Rejected (" +
                                                    _vm._s(_vm.countRejected) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-40 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 4
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 4
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium "
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Published (" +
                                                    _vm._s(_vm.countPublished) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableSong",
                    staticClass: "song-management",
                    attrs: {
                      data: _vm.data,
                      total: _vm.total,
                      "pagination-props": { background: true, pageSizes: [6] }
                    },
                    on: { "query-change": _vm.onChangeTable }
                  },
                  [
                    _vm._l(_vm.titles, function(title) {
                      return _c("el-table-column", {
                        key: title.prop.field,
                        attrs: {
                          prop: title.prop.field,
                          label: title.label,
                          sortable: "custom",
                          width: title.prop.width
                        }
                      })
                    }),
                    _vm._v(" "),
                    !_vm.isArtist &&
                    _vm.filterStatus !== 2 &&
                    _vm.filterStatus !== 3
                      ? _c("el-table-column", {
                          attrs: { label: "Elapsed Day", width: "130px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.elapsed_day) +
                                        "\n          "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1058782740
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isArtist && _vm.filterStatus == 3
                      ? _c("el-table-column", {
                          attrs: { label: "Note", width: "80px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                        on: {
                                          click: function($event) {
                                            return _vm.viewNote(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "text-white",
                                          attrs: { icon: ["fa", "eye"] }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2498829366
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isArtist
                      ? _c("el-table-column", {
                          attrs: { label: "Song", width: "250px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "audio",
                                      {
                                        staticClass: "audio-player",
                                        staticStyle: { width: "240px" },
                                        attrs: {
                                          controls: "",
                                          src: scope.row.file,
                                          id: "audioPlayer" + scope.row.id,
                                          controlsList: "nodownload",
                                          type: "audio/mp3",
                                          preload: "none"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Audio tag not supported\n            "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            389842424
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isArtist || _vm.isRecruitment || _vm.isFinance
                      ? _c("el-table-column", {
                          staticClass: "text-center",
                          attrs: { label: "Publish", width: "120px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          scope.row.published
                                            ? "Published"
                                            : "Not Published"
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1068105525
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.isAdmin ||
                      _vm.isSuperAdmin ||
                      _vm.isOps ||
                      _vm.isRecruitment) &&
                    _vm.filterStatus !== 0 &&
                    _vm.filterStatus !== 1 &&
                    _vm.filterStatus !== 3
                      ? _c("el-table-column", {
                          staticClass: "text-center",
                          attrs: {
                            label: "Publish",
                            width: "100px",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "flex items-center",
                                        class: _vm.isEligiblePublished(
                                          scope.row
                                        )
                                          ? "cursor-pointer"
                                          : "cursor-not-allowed",
                                        staticStyle: { height: "50px" },
                                        attrs: { for: "toogle" + scope.row.id }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "relative m-auto" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: scope.row.published,
                                                  expression:
                                                    "scope.row.published"
                                                }
                                              ],
                                              staticClass: "hidden",
                                              attrs: {
                                                id: "toogle" + scope.row.id,
                                                type: "checkbox",
                                                disabled: !_vm.isEligiblePublished(
                                                  scope.row
                                                )
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  scope.row.published
                                                )
                                                  ? _vm._i(
                                                      scope.row.published,
                                                      null
                                                    ) > -1
                                                  : scope.row.published
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a =
                                                        scope.row.published,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            scope.row,
                                                            "published",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            scope.row,
                                                            "published",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        scope.row,
                                                        "published",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                  function($event) {
                                                    return _vm.submitPublished(
                                                      scope.row
                                                    )
                                                  }
                                                ]
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4170694975
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isArtist
                      ? _c("el-table-column", {
                          staticClass: "text-center",
                          attrs: {
                            label: "Album Only",
                            width: "120px",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "flex items-center",
                                        staticStyle: { height: "50px" },
                                        attrs: { for: "toogle" + scope.row.id }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "relative m-auto" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    scope.row.is_album_only,
                                                  expression:
                                                    "scope.row.is_album_only"
                                                }
                                              ],
                                              staticClass: "hidden",
                                              attrs: {
                                                id: "toogle" + scope.row.id,
                                                type: "checkbox"
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  scope.row.is_album_only
                                                )
                                                  ? _vm._i(
                                                      scope.row.is_album_only,
                                                      null
                                                    ) > -1
                                                  : scope.row.is_album_only
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a =
                                                        scope.row.is_album_only,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            scope.row,
                                                            "is_album_only",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            scope.row,
                                                            "is_album_only",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        scope.row,
                                                        "is_album_only",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                  function($event) {
                                                    return _vm.changeAlbumOnly(
                                                      scope.row,
                                                      scope.row.is_album_only
                                                    )
                                                  }
                                                ]
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2454009411
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isArtist ||
                    _vm.isAdmin ||
                      _vm.isSuperAdmin ||
                      _vm.isOps ||
                      _vm.isReviewer
                      ? _c("el-table-column", {
                          attrs: {
                            label: "Actions",
                            align: "right",
                            width: "200px",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-left container-action"
                                      },
                                      [
                                        _vm.isArtist
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Detail",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.detail(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "eye"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isArtist
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Edit",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.edit(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "pencil-alt"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isOps &&
                                        !_vm.isReviewer &&
                                        !_vm.isArtist &&
                                        scope.row.canDelete
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Delete",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "w-8 mr-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteSong(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "trash-alt"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (_vm.isAdmin ||
                                          _vm.isSuperAdmin ||
                                          _vm.isOps ||
                                          _vm.isReviewer) &&
                                        _vm.isEligibleUnderReview(scope.row)
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Set Under Review",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-purple-400 hover:bg-purple-500 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.submitUnderReview(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "file-alt"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (_vm.isAdmin ||
                                          _vm.isSuperAdmin ||
                                          _vm.isOps ||
                                          _vm.isReviewer) &&
                                        _vm.isEligibleApproved(scope.row)
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Approve",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.submitApproved(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "check"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (_vm.isAdmin ||
                                          _vm.isSuperAdmin ||
                                          _vm.isOps ||
                                          _vm.isReviewer) &&
                                        _vm.isEligibleRejected(scope.row)
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Reject",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 rounded bg-red-700 hover:bg-red-800 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showingRejectModal(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "times"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (_vm.isAdmin ||
                                          _vm.isSuperAdmin ||
                                          _vm.isOps ||
                                          _vm.isReviewer) &&
                                        scope.row.statusCode == 2
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Add Tags",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addTags(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "tags"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3310848664
                          )
                        })
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addSongDetail",
          attrs: {
            isShowingModal: _vm.isShowingModal,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            title: "Song Details"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModal = !_vm.isShowingModal
            },
            save: function($event) {
              return _vm.submit()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("AddSong", {
                ref: "addSongContent",
                attrs: {
                  "toggle-reset": _vm.isShowingModal,
                  "musicverse-cut": _vm.getUser.musicverse_cut,
                  "artist-cut": _vm.getUser.artist_cut
                },
                on: { "on-submit-song": _vm.onSubmitSong }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "editSongDetail",
          attrs: {
            isShowingModal: _vm.isShowingModalEditSong,
            labelSubmit: "Save",
            isLoading: _vm.isLoading,
            error: _vm.isError,
            title: "Edit Song Details"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalEditSong = !_vm.isShowingModalEditSong
            },
            save: function($event) {
              return _vm.submitEdit()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("EditSong", {
                ref: "editSongContent",
                attrs: {
                  "toggle-reset": _vm.isShowingModalEditSong,
                  song: _vm.song,
                  "musicverse-cut": _vm.getUser.musicverse_cut,
                  "artist-cut": _vm.getUser.artist_cut
                },
                on: { "on-edit-song": _vm.onSubmitEditSong }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialogDetail",
        {
          ref: "detailSong",
          attrs: {
            isShowingModal: _vm.isShowingDetailModal,
            isLoading: _vm.isLoading,
            title: "Song Details"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingDetailModal = !_vm.isShowingDetailModal
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("SongDetail", {
                attrs: {
                  "toggle-reset": _vm.isShowingDetailModal,
                  song: _vm.song
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "submissionRejection",
          attrs: {
            isShowingModal: _vm.isShowingModalReject,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Submit Rejection",
            title: "Reject Submission"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalReject = !_vm.isShowingModalReject
            },
            save: function($event) {
              return _vm.submitRejected()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("RejectionForm", {
                ref: "songRejectionForm",
                attrs: {
                  "toggle-reset": _vm.isShowingModalReject,
                  filter: _vm.filter,
                  "song-rejection": _vm.songRejection
                },
                on: { "on-submit-rejection": _vm.onSubmitRejectionForm }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialogDetail",
        {
          ref: "songNote",
          attrs: {
            isShowingModal: _vm.isShowingModalNote,
            title: "Rejection Note"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalNote = false
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "flex flex-col w-full py-4" },
              [
                _c("form-item", {
                  attrs: { label: "Artist Name" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.songRejectionNote.artist))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Song Name" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.songRejectionNote.title))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Song Description" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.songRejectionNote.description))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Rejection Note" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.songRejectionNote.note))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addTags",
          attrs: {
            isShowingModal: _vm.isShowingModalTags,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Save",
            title: "Add Tags"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalTags = false
            },
            save: function($event) {
              return _vm.submitTags()
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "w-full py-4" },
              [
                _c(
                  "form-item",
                  { attrs: { label: "Tags" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "w-full",
                        attrs: {
                          multiple: "",
                          filterable: "",
                          remote: "",
                          "allow-create": "",
                          "default-first-option": "",
                          "reserve-keyword": "",
                          size: "large",
                          placeholder: "Please enter a keyword",
                          "remote-method": _vm.searchTags,
                          loading: _vm.loadingTags
                        },
                        model: {
                          value: _vm.tagsValue,
                          callback: function($$v) {
                            _vm.tagsValue = $$v
                          },
                          expression: "tagsValue"
                        }
                      },
                      _vm._l(_vm.tagsOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d3ff97a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d3ff97a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/contents/SongManagement.vue
// module id = null
// module chunks = 